import { Locale } from '@ps-smart-cp/ppfw-client';

const entryDateSelectionNameConfig = {
  currentMonth: new Map([
    [Locale.ja, '当月'],
    [Locale.en, 'Current Month'],
  ]),
  currentQuarter: new Map([
    [Locale.ja, '当四半期'],
    [Locale.en, 'Current Quarter'],
  ]),
  currentHalf: new Map([
    [Locale.ja, '当半期'],
    [Locale.en, 'Current Half'],
  ]),
  currentPeriod: new Map([
    [Locale.ja, '当期'],
    [Locale.en, 'Current Period'],
  ]),
  quarter1: new Map([
    [Locale.ja, '第1四半期'],
    [Locale.en, 'Quarter 1'],
  ]),
  quarter2: new Map([
    [Locale.ja, '第2四半期'],
    [Locale.en, 'Quarter 2'],
  ]),
  quarter3: new Map([
    [Locale.ja, '第3四半期'],
    [Locale.en, 'Quarter 3'],
  ]),
  quarter4: new Map([
    [Locale.ja, '第4四半期'],
    [Locale.en, 'Quarter 4'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { entryDateSelectionNameConfig };
